<h1>
  {{ message | translate }}
</h1>